var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4 3.67072H3.6C2.72 3.67072 2.008 4.40486 2.008 5.30215L2 15.0907C2 15.988 2.72 16.7222 3.6 16.7222H16.4C17.28 16.7222 18 15.988 18 15.0907V5.30215C18 4.40486 17.28 3.67072 16.4 3.67072ZM16.08 7.1375L10.424 10.743C10.168 10.9061 9.832 10.9061 9.576 10.743L3.92 7.1375C3.83978 7.09159 3.76954 7.02955 3.71351 6.95515C3.65749 6.88076 3.61685 6.79554 3.59406 6.70466C3.57127 6.61379 3.5668 6.51914 3.58093 6.42645C3.59505 6.33376 3.62747 6.24496 3.67623 6.16542C3.72498 6.08588 3.78906 6.01725 3.86458 5.96369C3.9401 5.91013 4.0255 5.87275 4.1156 5.85381C4.2057 5.83488 4.29863 5.83478 4.38876 5.85353C4.4789 5.87227 4.56437 5.90947 4.64 5.96287L10 9.38072L15.36 5.96287C15.4356 5.90947 15.5211 5.87227 15.6112 5.85353C15.7014 5.83478 15.7943 5.83488 15.8844 5.85381C15.9745 5.87275 16.0599 5.91013 16.1354 5.96369C16.2109 6.01725 16.275 6.08588 16.3238 6.16542C16.3725 6.24496 16.405 6.33376 16.4191 6.42645C16.4332 6.51914 16.4287 6.61379 16.4059 6.70466C16.3832 6.79554 16.3425 6.88076 16.2865 6.95515C16.2305 7.02955 16.1602 7.09159 16.08 7.1375Z",
    fill: "white",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.71684789632ca16719c41947a38adf68.svg";
export { ForwardRef as ReactComponent };